import script from "./TableFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./TableFooter.vue?vue&type=script&setup=true&lang=js"

import "./TableFooter.vue?vue&type=style&index=0&id=a30662d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a30662d4"]])

export default __exports__